/* eslint-disable require-jsdoc */

export function selectNewsCategories(state) {
    return state.newsCategories.items;
}
